function logosMobile() {
	const blocks = document.querySelectorAll('.block-logos__container');

	if(blocks) {
		blocks.forEach(block => {
			const prev = block.querySelector('.block-logos__prev');
			const next = block.querySelector('.block-logos__next');
			const firstItem = block.querySelector('.block-logos__logos > div:first-child');
			const lastItem = block.querySelector('.block-logos__logos > div:last-child');
			const max = parseInt(lastItem.getAttribute('data-num'));
			const items = block.querySelectorAll('.block-logos__logos > div');

			function getCurrent() {
				let current;

				items.forEach(item => {
					if (item.classList.contains('active')) {
						current = parseInt(item.getAttribute('data-num'));
					}
				});

				return current;
			}

			function resetAll() {
				items.forEach(item => {
					item.classList.remove('active');
				});
			}

			prev.addEventListener('click', function() {
				const current = getCurrent();
				resetAll();

				if (current === 1) {
					block.querySelector(`.block-logos__logo[data-num="${max}"]`).classList.add('active');
				}
				else {
					block.querySelector(`.block-logos__logo[data-num="${current - 1}"]`).classList.add('active');
				}
			});

			next.addEventListener('click', function() {
				const current = getCurrent();
				resetAll();

				if (current === max) {
					block.querySelector(`.block-logos__logo[data-num="1"]`).classList.add('active');
				}
				else {
					block.querySelector(`.block-logos__logo[data-num="${current + 1}"]`).classList.add('active');
				}
			});
		});
	}
}

export default logosMobile;